export const SET_SHARE_URL = 'SET_SHARE_URL'
export const DISSOC_SHARE_URL = 'DISSOC_SHARE_URL'
export const CLEAR_MODAL = 'CLEAR_MODAL'
